import {h, Fragment} from "preact"
import { SKELETON_LOADER_PRODUCT_CARDS } from "../config"

export default function Skeleton() {
  const items = Array.from({ length: SKELETON_LOADER_PRODUCT_CARDS });

  return (
    <div id="ns-collection-skel__container">
      <div className="ss-results__top-wrapper page-width">
        <hr className="ss-results__top-border" />
      </div>

      <div className="ss-results__top-wrapper collection-skel__top-wrapper page-width">
        <div className="collection-skel__product-count"></div>
        <div className="collection-skel__toolbar"></div>
      </div>

      <div className="collection-skel__container">
        {items.map((_, index) => (
          <div key={index} className="collection-skel__item">
            <div className="collection-skel__image"></div>
            <div className="collection-skel__name"></div>
            <div className="collection-skel__swatches"></div>
          </div>
        ))}
      </div>
    </div>
  );
};